var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.478 4 1.076.986a6.528 6.528 0 0 0-2.1 4.803c0 1.898.809 3.608 2.1 4.803l-1.076.986A7.977 7.977 0 0 1 2 9.79C2 7.512 2.951 5.457 4.478 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.817 9.79a2.182 2.182 0 1 0 4.364 0 2.182 2.182 0 0 0-4.364 0Zm2.91 0a.727.727 0 1 1-1.455 0 .727.727 0 0 1 1.455 0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.63 5.973 1.081.99A3.63 3.63 0 0 0 6.364 9.79a3.63 3.63 0 0 0 1.347 2.826l-1.08.99A5.08 5.08 0 0 1 4.908 9.79c0-1.52.666-2.883 1.721-3.816ZM15.522 4A7.977 7.977 0 0 1 18 9.789a7.977 7.977 0 0 1-2.478 5.79l-1.076-.987a6.528 6.528 0 0 0 2.1-4.803 6.528 6.528 0 0 0-2.1-4.803L15.522 4Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.37 5.973a5.079 5.079 0 0 1 1.722 3.816c0 1.52-.666 2.884-1.721 3.817l-1.08-.99a3.63 3.63 0 0 0 1.346-2.827 3.63 3.63 0 0 0-1.347-2.825l1.08-.99Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.6e6a0a05.svg";
export { ForwardRef as ReactComponent };